import { connect }                     from 'react-redux'
import { startWatching, stopWatching } from './../../actions/GeoLocationAction';
import GeoToggle                       from '../../components/Banner/GeoToggle';
import { geoResetInformed }            from './../../actions/GeoLocationAction';


const mapStateToProps = (state) => {
    return {
        theme: state.assets.items.theme.banner,
        geo  : state.geo
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        geoStartWatching: () => {
            dispatch(startWatching());
        },
        geoStopWatching: () => {
            dispatch(stopWatching());
        },
        geoResetInformed: () => {
            dispatch(geoResetInformed());
        }
    }
};

const GeoToggleContainer = connect(mapStateToProps, mapDispatchToProps)(GeoToggle);

export default GeoToggleContainer;


// WEBPACK FOOTER //
// ./src/containers/Banner/GeoToggleContainer.js